const env_config = {
    "development":{
        "cloud_function_url":"https://us-east4-dl-rp-universe.cloudfunctions.net/rp-dev"
    },
    "test":{
        "cloud_function_url":"https://us-east4-dl-rp-universe.cloudfunctions.net/rp-test"
    },
    "production":{
        "cloud_function_url":"https://us-east4-dl-rp-universe.cloudfunctions.net/rp-prod"
    }
}

module.exports = env_config